module.exports = __webpack_public_path__ + "img/review7pp.bd078ac1.png";